import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import fetch from 'isomorphic-unfetch';
var VERSION = '4';
var isBrowser = typeof window !== 'undefined' && window != null && typeof window.document !== 'undefined';

var Api = /*#__PURE__*/function () {
  function Api(opts) {
    _classCallCheck(this, Api);

    var _opts$host;

    this.opts = opts;
    this.host = (_opts$host = opts.host) != null ? _opts$host : 'https://codegen.plasmic.app';
  }

  _createClass(Api, [{
    key: "fetchLoaderData",
    value: function () {
      var _fetchLoaderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectIds, opts) {
        var platform, preview, query, url, resp, _error$error$message, _error$error, error, json;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                platform = opts.platform, preview = opts.preview;
                query = new URLSearchParams([['platform', platform != null ? platform : 'react']].concat(_toConsumableArray(projectIds.map(function (projectId) {
                  return ['projectId', projectId];
                })), _toConsumableArray(opts.browserOnly ? [['browserOnly', 'true']] : []))).toString();
                url = "".concat(this.host, "/api/v1/loader/code/").concat(preview ? 'preview' : 'published', "?").concat(query);
                _context.next = 5;
                return fetch(url, {
                  method: 'GET',
                  headers: this.makeGetHeaders()
                });

              case 5:
                resp = _context.sent;

                if (!(resp.status >= 400)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return resp.json();

              case 9:
                error = _context.sent;
                throw new Error((_error$error$message = error == null ? void 0 : (_error$error = error.error) == null ? void 0 : _error$error.message) != null ? _error$error$message : resp.statusText);

              case 11:
                _context.next = 13;
                return resp.json();

              case 13:
                json = _context.sent;
                return _context.abrupt("return", json);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchLoaderData(_x, _x2) {
        return _fetchLoaderData.apply(this, arguments);
      }

      return fetchLoaderData;
    }()
  }, {
    key: "fetchHtmlData",
    value: function () {
      var _fetchHtmlData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
        var projectId, component, embedHydrate, hydrate, query, resp, json;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                projectId = opts.projectId, component = opts.component, embedHydrate = opts.embedHydrate, hydrate = opts.hydrate;
                query = new URLSearchParams([['projectId', projectId], ['component', component], ['embedHydrate', embedHydrate ? '1' : '0'], ['hydrate', hydrate ? '1' : '0']]).toString();
                _context2.next = 4;
                return fetch("".concat(this.host, "/api/v1/loader/html?").concat(query), {
                  method: 'GET',
                  headers: this.makeGetHeaders()
                });

              case 4:
                resp = _context2.sent;
                _context2.next = 7;
                return resp.json();

              case 7:
                json = _context2.sent;
                return _context2.abrupt("return", json);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchHtmlData(_x3) {
        return _fetchHtmlData.apply(this, arguments);
      }

      return fetchHtmlData;
    }()
  }, {
    key: "makeGetHeaders",
    value: function makeGetHeaders() {
      return _objectSpread({
        'x-plasmic-loader-version': VERSION
      }, this.makeAuthHeaders());
    } // @ts-ignore

  }, {
    key: "makePostHeaders",
    value: function makePostHeaders() {
      return _objectSpread({
        'x-plasmic-loader-version': VERSION,
        'Content-Type': 'application/json'
      }, this.makeAuthHeaders());
    }
  }, {
    key: "makeAuthHeaders",
    value: function makeAuthHeaders() {
      var tokens = this.opts.projects.map(function (p) {
        return "".concat(p.id, ":").concat(p.token);
      }).join(',');
      return {
        'x-plasmic-api-project-tokens': tokens
      };
    }
  }]);

  return Api;
}();

var PlasmicModulesFetcher = /*#__PURE__*/function () {
  function PlasmicModulesFetcher(opts) {
    _classCallCheck(this, PlasmicModulesFetcher);

    this.opts = opts;
    this.curFetch = undefined;
    this.api = new Api({
      projects: opts.projects,
      host: opts.host
    });
  }

  _createClass(PlasmicModulesFetcher, [{
    key: "fetchAllData",
    value: function () {
      var _fetchAllData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var cachedData, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.opts.cache) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 3;
                return this.opts.cache.get();

              case 3:
                cachedData = _context3.sent;

                if (!cachedData) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", cachedData);

              case 6:
                if (!this.curFetch) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 9;
                return this.curFetch;

              case 9:
                return _context3.abrupt("return", _context3.sent);

              case 10:
                console.debug('Plasmic: doing a fresh fetch...');
                this.curFetch = this.doFetch();
                _context3.next = 14;
                return this.curFetch;

              case 14:
                data = _context3.sent;
                this.curFetch = undefined;
                return _context3.abrupt("return", data);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchAllData() {
        return _fetchAllData.apply(this, arguments);
      }

      return fetchAllData;
    }()
  }, {
    key: "doFetch",
    value: function () {
      var _doFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.api.fetchLoaderData(this.opts.projects.map(function (p) {
                  return p.version && !_this.opts.preview ? "".concat(p.id, "@").concat(p.version) : p.id;
                }), {
                  platform: this.opts.platform,
                  preview: this.opts.preview,
                  browserOnly: isBrowser
                });

              case 2:
                data = _context4.sent;

                if (!this.opts.cache) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return this.opts.cache.set(data);

              case 6:
                console.debug("Plasmic: fetched designs for ".concat(data.projects.map(function (p) {
                  return "\"".concat(p.name, "\" (").concat(p.id, "@").concat(p.version, ")");
                }).join(', ')));
                return _context4.abrupt("return", data);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function doFetch() {
        return _doFetch.apply(this, arguments);
      }

      return doFetch;
    }()
  }]);

  return PlasmicModulesFetcher;
}();

export { Api, PlasmicModulesFetcher };